// StyLsTime Global JS

// Scroll Reveal
const revealEls = document.querySelectorAll('.st-reveal, .st-reveal-left');
if (revealEls.length) {
  const observer = new IntersectionObserver((entries) => {
    entries.forEach(e => { if (e.isIntersecting) { e.target.classList.add('st-visible'); observer.unobserve(e.target); } });
  }, { threshold: 0.15 });
  revealEls.forEach(el => observer.observe(el));
}

// ============================================
// Compare At Price Fix
// ============================================
function fixComparePrices() {
  const containers = document.querySelectorAll('product-price');
  containers.forEach(container => {
    const priceEl = container.querySelector('.price');
    const compareEl = container.querySelector('.compare-at-price');
    if (!priceEl) return;

    // Get variant data from the page
    const productJson = document.getElementById('ProductJson-product-template') ||
                        document.querySelector('[data-product-json]') ||
                        document.querySelector('script[type="application/json"][data-product-id]');

    // Try to get compare price from variant data in the form
    const variantIdInput = document.querySelector('input[name="id"]');
    if (!variantIdInput) return;

    const variantId = variantIdInput.value;
    const allVariantData = document.querySelectorAll('[data-compare-price]');

    allVariantData.forEach(el => {
      if (el.dataset.variantId === variantId) {
        const comparePrice = parseFloat(el.dataset.comparePrice);
        const price = parseFloat(el.dataset.price);
        if (comparePrice > price && !compareEl) {
          const span = document.createElement('span');
          span.className = 'compare-at-price';
          span.textContent = el.dataset.comparePriceFormatted;
          priceEl.insertAdjacentElement('afterend', span);
        }
      }
    });
  });
}

document.addEventListener('DOMContentLoaded', fixComparePrices);
